<div role="contentinfo" class="contentSection footer clearfix">
  <div class="container BG-color-Grey">
    <div class="row">
      <div class="col-xs-2 text-left">
        <a [attr.href]="footerContent?.linkUrl" class="footer-link" (click)="onFooterClick()" tabindex="0" title="Citibank logo">
          <img role="presentation" src={{imagePrefix}}{{footerContent?.imageURL}} height="35" class="footerLogo" aria-hidden="true"
            alt="Citi logo"></a>
      </div>
      <div class="col-xs-10 text-right padding-right-0" id="footerLinks">
        <ul class="list-inline footerLinks">
          <li *ngFor="let link of footerContent?.links; let i = index">
            <a href="{{link.linkURL}}" target="_blank" rel="noopener" [innerHTML]="link.text" tabindex="0"
              [ngClass]="{'privacyLinks': link.key === 'privacy' || link.key === 'notice_at_collection', 'privacyLink': link.key === 'privacy', 'NACLink': link.key === 'notice_at_collection', 'CAPHLink': link.key === 'ca_privacy_hub'}"></a>
          </li>
          <li class="{{icon.elementId+'-class'}}"
            *ngFor="let icon of footerContent?.footerCategories[0].footerCategoryItems; let i = index">
            <a href="javascript:void(0)" id="{{icon.elementId}}" role="button" (click)="openModal($event, 0 , i);"
              aria-haspopup="dialog" dataTarget="#modalID">{{icon?.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-xs-6 text-left footerDisclaimer copywrightInfo" id="copyright">
        <p>Copyright© <span id="dinYear">{{date | date:'yyyy'}}</span> {{ footerContent?.copyrightCompanyName ||
          'Citigroup Inc' }}. </p>
      </div>
      <div class="col-xs-6 padding-0 text-right" id="securityImage">
        <div class="security-wrapper">
          <ul>
            <li><img role="presentation" src={{imagePrefix}}{{footerContent?.fdicLogo}} alt="Member FDIC logo"></li>
            <li><img role="presentation" src={{imagePrefix}}{{footerContent?.housing}} alt="Equal Housing Lender"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
